(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './Stately-stately-concurrency.js', './Stately-stately-concurrent-collections.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./Stately-stately-concurrency.js'), require('./Stately-stately-concurrent-collections.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'projects-core-koin-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'projects-core-koin-core'.");
    }
    if (typeof globalThis['Stately-stately-concurrency'] === 'undefined') {
      throw new Error("Error loading module 'projects-core-koin-core'. Its dependency 'Stately-stately-concurrency' was not found. Please, check whether 'Stately-stately-concurrency' is loaded prior to 'projects-core-koin-core'.");
    }
    if (typeof globalThis['Stately-stately-concurrent-collections'] === 'undefined') {
      throw new Error("Error loading module 'projects-core-koin-core'. Its dependency 'Stately-stately-concurrent-collections' was not found. Please, check whether 'Stately-stately-concurrent-collections' is loaded prior to 'projects-core-koin-core'.");
    }
    globalThis['projects-core-koin-core'] = factory(typeof globalThis['projects-core-koin-core'] === 'undefined' ? {} : globalThis['projects-core-koin-core'], globalThis['kotlin-kotlin-stdlib'], globalThis['Stately-stately-concurrency'], globalThis['Stately-stately-concurrent-collections']);
  }
}(function (_, kotlin_kotlin, kotlin_co_touchlab_stately_concurrency, kotlin_co_touchlab_stately_concurrent_collections) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.eh;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var Monotonic_instance = kotlin_kotlin.$_$.f3;
  var ValueTimeMark__elapsedNow_impl_eonqvs = kotlin_kotlin.$_$.p;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var toList = kotlin_kotlin.$_$.lc;
  var VOID = kotlin_kotlin.$_$.d;
  var emptyList = kotlin_kotlin.$_$.c9;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var equals = kotlin_kotlin.$_$.sf;
  var joinTo = kotlin_kotlin.$_$.ca;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var hashCode = kotlin_kotlin.$_$.bg;
  var Enum = kotlin_kotlin.$_$.en;
  var toString = kotlin_kotlin.$_$.hp;
  var toString_0 = kotlin_kotlin.$_$.hh;
  var Exception = kotlin_kotlin.$_$.gn;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.h5;
  var captureStack = kotlin_kotlin.$_$.gf;
  var Exception_init_$Init$_0 = kotlin_kotlin.$_$.j5;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.d4;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var asReversed = kotlin_kotlin.$_$.u7;
  var ArrayDeque_init_$Create$ = kotlin_kotlin.$_$.y3;
  var asReversed_0 = kotlin_kotlin.$_$.t7;
  var get_lastIndex = kotlin_kotlin.$_$.fa;
  var toList_0 = kotlin_kotlin.$_$.kc;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var toMutableList = kotlin_kotlin.$_$.qc;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var getKClass = kotlin_kotlin.$_$.si;
  var copyToArray = kotlin_kotlin.$_$.x8;
  var arrayListOf = kotlin_kotlin.$_$.r7;
  var KtMap = kotlin_kotlin.$_$.g7;
  var isInterface = kotlin_kotlin.$_$.rg;
  var listOf = kotlin_kotlin.$_$.sa;
  var plus = kotlin_kotlin.$_$.ib;
  var TimedValue = kotlin_kotlin.$_$.qm;
  var ArrayDeque_init_$Create$_0 = kotlin_kotlin.$_$.x3;
  var ThreadLocalRef = kotlin_co_touchlab_stately_concurrency.$_$.a;
  var _Duration___get_inWholeMicroseconds__impl__8oe8vv = kotlin_kotlin.$_$.h;
  var toNumber = kotlin_kotlin.$_$.bf;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var Companion_getInstance = kotlin_kotlin.$_$.g3;
  var Exception_init_$Create$ = kotlin_kotlin.$_$.g5;
  var split = kotlin_kotlin.$_$.cl;
  var ConcurrentMutableMap_init_$Create$ = kotlin_co_touchlab_stately_concurrent_collections.$_$.a;
  var ConcurrentMutableSet_init_$Create$ = kotlin_co_touchlab_stately_concurrent_collections.$_$.b;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Koin, 'Koin', Koin);
  initMetadataForCompanion(Companion);
  initMetadataForClass(KoinApplication, 'KoinApplication');
  initMetadataForClass(BeanDefinition, 'BeanDefinition');
  initMetadataForClass(Kind, 'Kind', VOID, Enum);
  initMetadataForClass(Callbacks, 'Callbacks', Callbacks);
  initMetadataForClass(KoinDefinition, 'KoinDefinition');
  initMetadataForClass(ClosedScopeException, 'ClosedScopeException', VOID, Exception);
  initMetadataForClass(DefinitionOverrideException, 'DefinitionOverrideException', VOID, Exception);
  initMetadataForClass(InstanceCreationException, 'InstanceCreationException', VOID, Exception);
  initMetadataForClass(KoinApplicationAlreadyStartedException, 'KoinApplicationAlreadyStartedException', VOID, Exception);
  initMetadataForClass(NoDefinitionFoundException, 'NoDefinitionFoundException', VOID, Exception);
  initMetadataForClass(NoParameterFoundException, 'NoParameterFoundException', VOID, Exception);
  initMetadataForClass(ScopeAlreadyCreatedException, 'ScopeAlreadyCreatedException', VOID, Exception);
  initMetadataForClass(ExtensionManager, 'ExtensionManager');
  initMetadataForClass(InstanceFactory, 'InstanceFactory');
  initMetadataForClass(FactoryInstanceFactory, 'FactoryInstanceFactory', VOID, InstanceFactory);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(ResolutionContext, 'ResolutionContext');
  initMetadataForClass(NoClass, 'NoClass', NoClass);
  initMetadataForClass(ScopedInstanceFactory, 'ScopedInstanceFactory', VOID, InstanceFactory);
  initMetadataForClass(SingleInstanceFactory, 'SingleInstanceFactory', VOID, InstanceFactory);
  initMetadataForClass(Logger, 'Logger');
  initMetadataForClass(EmptyLogger, 'EmptyLogger', EmptyLogger, Logger);
  initMetadataForClass(Level, 'Level', VOID, Enum);
  initMetadataForClass(Module, 'Module', Module);
  initMetadataForClass(KoinOption, 'KoinOption', VOID, Enum);
  initMetadataForClass(ParametersHolder, 'ParametersHolder', ParametersHolder);
  initMetadataForClass(StringQualifier, 'StringQualifier');
  initMetadataForClass(TypeQualifier, 'TypeQualifier');
  initMetadataForClass(InstanceRegistry, 'InstanceRegistry');
  initMetadataForClass(OptionRegistry, 'OptionRegistry', OptionRegistry);
  initMetadataForClass(PropertyRegistry, 'PropertyRegistry');
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(ScopeRegistry, 'ScopeRegistry');
  initMetadataForClass(CoreResolverV2, 'CoreResolverV2');
  initMetadataForClass(Scope, 'Scope');
  initMetadataForObject(KoinPlatform, 'KoinPlatform');
  initMetadataForObject(GlobalContext, 'GlobalContext');
  initMetadataForObject(KoinPlatformTools, 'KoinPlatformTools');
  //endregion
  function Koin() {
    this.cs2_1 = new EmptyLogger();
    this.ds2_1 = new CoreResolverV2(this);
    this.es2_1 = new ScopeRegistry(this);
    this.fs2_1 = new InstanceRegistry(this);
    this.gs2_1 = new PropertyRegistry(this);
    this.hs2_1 = new ExtensionManager(this);
    this.is2_1 = new OptionRegistry();
  }
  protoOf(Koin).js2 = function (scopeId, qualifier, source, scopeArchetype) {
    return this.es2_1.os2(scopeId, qualifier, source, scopeArchetype);
  };
  protoOf(Koin).ps2 = function (scopeId) {
    this.es2_1.qs2(scopeId);
  };
  protoOf(Koin).rs2 = function (modules, allowOverride, createEagerInstances) {
    var flattedModules = flatten(modules);
    this.fs2_1.vs2(flattedModules, allowOverride);
    this.es2_1.ws2(flattedModules);
    if (createEagerInstances) {
      this.xs2();
    }
  };
  protoOf(Koin).xs2 = function () {
    this.cs2_1.zs2('Create eager instances ...');
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.time.measureTime' call
    var mark = Monotonic_instance.mf();
    this.fs2_1.as3();
    var duration = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    this.cs2_1.zs2('Created eager instances in ' + get_inMs(duration) + ' ms');
  };
  function loadModules($this, modules) {
    $this.bs3_1.rs2(modules, $this.cs3_1, false);
  }
  function Companion() {
  }
  protoOf(Companion).df7 = function () {
    var app = new KoinApplication();
    return app;
  };
  var Companion_instance;
  function Companion_getInstance_0() {
    return Companion_instance;
  }
  function KoinApplication() {
    this.bs3_1 = new Koin();
    this.cs3_1 = true;
  }
  protoOf(KoinApplication).ds3 = function (modules) {
    return this.es3(toList(modules));
  };
  protoOf(KoinApplication).es3 = function (modules) {
    var tmp0 = this.bs3_1.cs2_1;
    // Inline function 'org.koin.core.logger.Logger.isAt' call
    var lvl = Level_INFO_getInstance();
    if (tmp0.ys2_1.i3(lvl) <= 0) {
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.time.measureTime' call
      var mark = Monotonic_instance.mf();
      loadModules(this, modules);
      var duration = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
      var count = this.bs3_1.fs2_1.a19();
      this.bs3_1.cs2_1.fs3(Level_INFO_getInstance(), 'Started ' + count + ' definitions in ' + get_inMs(duration) + ' ms');
    } else {
      loadModules(this, modules);
    }
    return this;
  };
  function startKoin(appDeclaration) {
    return KoinPlatformTools_instance.gs3().hs3(appDeclaration);
  }
  function BeanDefinition$toString$lambda(it) {
    return getFullName(it);
  }
  function BeanDefinition(scopeQualifier, primaryType, qualifier, definition, kind, secondaryTypes, allowOverride) {
    qualifier = qualifier === VOID ? null : qualifier;
    secondaryTypes = secondaryTypes === VOID ? emptyList() : secondaryTypes;
    allowOverride = allowOverride === VOID ? null : allowOverride;
    this.is3_1 = scopeQualifier;
    this.js3_1 = primaryType;
    this.ks3_1 = qualifier;
    this.ls3_1 = definition;
    this.ms3_1 = kind;
    this.ns3_1 = secondaryTypes;
    this.os3_1 = allowOverride;
    this.ps3_1 = new Callbacks();
    this.qs3_1 = false;
  }
  protoOf(BeanDefinition).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    this_0.s(_Char___init__impl__6a9atx(91));
    this_0.w(this.ms3_1);
    this_0.q(": '");
    this_0.q(getFullName(this.js3_1));
    this_0.s(_Char___init__impl__6a9atx(39));
    if (!(this.ks3_1 == null)) {
      this_0.q(',qualifier:');
      this_0.w(this.ks3_1);
    }
    if (!equals(this.is3_1, Companion_getInstance_2().ss3_1)) {
      this_0.q(',scope:');
      this_0.w(this.is3_1);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.ns3_1.r()) {
      this_0.q(',binds:');
      var tmp = this.ns3_1;
      joinTo(tmp, this_0, ',', VOID, VOID, VOID, VOID, BeanDefinition$toString$lambda);
    }
    this_0.s(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  };
  protoOf(BeanDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BeanDefinition))
      THROW_CCE();
    if (!this.js3_1.equals(other.js3_1))
      return false;
    if (!equals(this.ks3_1, other.ks3_1))
      return false;
    if (!equals(this.is3_1, other.is3_1))
      return false;
    return true;
  };
  protoOf(BeanDefinition).hashCode = function () {
    var tmp0_safe_receiver = this.ks3_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    result = imul(31, result) + this.js3_1.hashCode() | 0;
    result = imul(31, result) + hashCode(this.is3_1) | 0;
    return result;
  };
  var Kind_Singleton_instance;
  var Kind_Factory_instance;
  var Kind_Scoped_instance;
  var Kind_entriesInitialized;
  function Kind_initEntries() {
    if (Kind_entriesInitialized)
      return Unit_instance;
    Kind_entriesInitialized = true;
    Kind_Singleton_instance = new Kind('Singleton', 0);
    Kind_Factory_instance = new Kind('Factory', 1);
    Kind_Scoped_instance = new Kind('Scoped', 2);
  }
  function Kind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Kind_Singleton_getInstance() {
    Kind_initEntries();
    return Kind_Singleton_instance;
  }
  function Kind_Factory_getInstance() {
    Kind_initEntries();
    return Kind_Factory_instance;
  }
  function Callbacks(onClose) {
    onClose = onClose === VOID ? null : onClose;
    this.ts3_1 = onClose;
  }
  protoOf(Callbacks).toString = function () {
    return 'Callbacks(onClose=' + toString(this.ts3_1) + ')';
  };
  protoOf(Callbacks).hashCode = function () {
    return this.ts3_1 == null ? 0 : hashCode(this.ts3_1);
  };
  protoOf(Callbacks).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Callbacks))
      return false;
    if (!equals(this.ts3_1, other.ts3_1))
      return false;
    return true;
  };
  function KoinDefinition(module_0, factory) {
    this.us3_1 = module_0;
    this.vs3_1 = factory;
  }
  protoOf(KoinDefinition).toString = function () {
    return 'KoinDefinition(module=' + toString_0(this.us3_1) + ', factory=' + toString_0(this.vs3_1) + ')';
  };
  protoOf(KoinDefinition).hashCode = function () {
    var result = this.us3_1.hashCode();
    result = imul(result, 31) + hashCode(this.vs3_1) | 0;
    return result;
  };
  protoOf(KoinDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KoinDefinition))
      return false;
    if (!this.us3_1.equals(other.us3_1))
      return false;
    if (!equals(this.vs3_1, other.vs3_1))
      return false;
    return true;
  };
  function ClosedScopeException(msg) {
    Exception_init_$Init$(msg, this);
    captureStack(this, ClosedScopeException);
  }
  function DefinitionOverrideException(msg) {
    Exception_init_$Init$(msg, this);
    captureStack(this, DefinitionOverrideException);
  }
  function InstanceCreationException(msg, parent) {
    Exception_init_$Init$_0(msg, parent, this);
    captureStack(this, InstanceCreationException);
  }
  function KoinApplicationAlreadyStartedException(msg) {
    Exception_init_$Init$(msg, this);
    captureStack(this, KoinApplicationAlreadyStartedException);
  }
  function NoDefinitionFoundException(msg) {
    Exception_init_$Init$(msg, this);
    captureStack(this, NoDefinitionFoundException);
  }
  function NoParameterFoundException(msg) {
    Exception_init_$Init$(msg, this);
    captureStack(this, NoParameterFoundException);
  }
  function ScopeAlreadyCreatedException(s) {
    Exception_init_$Init$(s, this);
    captureStack(this, ScopeAlreadyCreatedException);
  }
  function ExtensionManager(_koin) {
    this.ws3_1 = _koin;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.xs3_1 = HashMap_init_$Create$();
  }
  function FactoryInstanceFactory(beanDefinition) {
    InstanceFactory.call(this, beanDefinition);
  }
  protoOf(FactoryInstanceFactory).zs3 = function (context) {
    return this.bs4(context);
  };
  function Companion_0() {
    this.cs4_1 = '\n\t';
  }
  var Companion_instance_0;
  function Companion_getInstance_1() {
    return Companion_instance_0;
  }
  function InstanceFactory(beanDefinition) {
    this.as4_1 = beanDefinition;
  }
  protoOf(InstanceFactory).bs4 = function (context) {
    context.ds4_1.zs2("| (+) '" + this.as4_1.toString() + "'");
    try {
      var tmp0_elvis_lhs = context.hs4_1;
      var parameters = tmp0_elvis_lhs == null ? emptyParametersHolder() : tmp0_elvis_lhs;
      return this.as4_1.ls3_1(context.es4_1, parameters);
    } catch ($p) {
      if ($p instanceof Exception) {
        var e = $p;
        var stack = KoinPlatformTools_instance.ks4(e);
        context.ds4_1.ls4("* Instance creation error : could not create instance for '" + this.as4_1.toString() + "': " + stack);
        throw new InstanceCreationException("Could not create instance for '" + this.as4_1.toString() + "'", e);
      } else {
        throw $p;
      }
    }
  };
  function ResolutionContext(logger, scope, clazz, qualifier, parameters) {
    qualifier = qualifier === VOID ? null : qualifier;
    parameters = parameters === VOID ? null : parameters;
    this.ds4_1 = logger;
    this.es4_1 = scope;
    this.fs4_1 = clazz;
    this.gs4_1 = qualifier;
    this.hs4_1 = parameters;
    this.is4_1 = "t:'" + getFullName(this.fs4_1) + "' - q:'" + toString(this.gs4_1) + "'";
    this.js4_1 = null;
  }
  protoOf(ResolutionContext).ms4 = function (s) {
    var rc = new ResolutionContext(this.ds4_1, s, this.fs4_1, this.gs4_1, this.hs4_1);
    rc.js4_1 = s.qs4_1;
    return rc;
  };
  function NoClass() {
  }
  function ScopedInstanceFactory$drop$lambda(this$0, $s) {
    return function () {
      var v = this$0.ys4_1.a3($s.os4_1);
      var tmp0_safe_receiver = this$0.as4_1.ps3_1.ts3_1;
      return tmp0_safe_receiver == null ? null : tmp0_safe_receiver(v);
    };
  }
  function ScopedInstanceFactory() {
  }
  protoOf(ScopedInstanceFactory).zs4 = function (scope) {
    if (scope == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp = KoinPlatformTools_instance;
      tmp.as5(this, ScopedInstanceFactory$drop$lambda(this, scope));
    }
  };
  function getValue($this) {
    var tmp0_elvis_lhs = $this.cs5_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = "Single instance created couldn't return value";
      throw IllegalStateException_init_$Create$(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function SingleInstanceFactory$get$lambda(this$0, $context) {
    return function () {
      var tmp;
      if (!this$0.ds5($context)) {
        this$0.cs5_1 = this$0.bs4($context);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SingleInstanceFactory(beanDefinition) {
    InstanceFactory.call(this, beanDefinition);
    this.cs5_1 = null;
  }
  protoOf(SingleInstanceFactory).ds5 = function (context) {
    return !(this.cs5_1 == null);
  };
  protoOf(SingleInstanceFactory).bs4 = function (context) {
    var tmp;
    if (this.cs5_1 == null) {
      tmp = protoOf(InstanceFactory).bs4.call(this, context);
    } else {
      tmp = getValue(this);
    }
    return tmp;
  };
  protoOf(SingleInstanceFactory).zs3 = function (context) {
    if (!this.ds5(context)) {
      var tmp = KoinPlatformTools_instance;
      tmp.as5(this, SingleInstanceFactory$get$lambda(this, context));
    }
    return getValue(this);
  };
  function EmptyLogger() {
    Logger.call(this, Level_NONE_getInstance());
  }
  protoOf(EmptyLogger).fs3 = function (level, msg) {
  };
  function Logger(level) {
    level = level === VOID ? Level_INFO_getInstance() : level;
    this.ys2_1 = level;
  }
  protoOf(Logger).zs2 = function (msg) {
    this.gs5(Level_DEBUG_getInstance(), msg);
  };
  protoOf(Logger).fs5 = function (msg) {
    this.gs5(Level_WARNING_getInstance(), msg);
  };
  protoOf(Logger).ls4 = function (msg) {
    this.gs5(Level_ERROR_getInstance(), msg);
  };
  protoOf(Logger).gs5 = function (lvl, msg) {
    // Inline function 'org.koin.core.logger.Logger.isAt' call
    if (this.ys2_1.i3(lvl) <= 0) {
      this.fs3(lvl, msg);
    }
  };
  var Level_DEBUG_instance;
  var Level_INFO_instance;
  var Level_WARNING_instance;
  var Level_ERROR_instance;
  var Level_NONE_instance;
  var Level_entriesInitialized;
  function Level_initEntries() {
    if (Level_entriesInitialized)
      return Unit_instance;
    Level_entriesInitialized = true;
    Level_DEBUG_instance = new Level('DEBUG', 0);
    Level_INFO_instance = new Level('INFO', 1);
    Level_WARNING_instance = new Level('WARNING', 2);
    Level_ERROR_instance = new Level('ERROR', 3);
    Level_NONE_instance = new Level('NONE', 4);
  }
  function Level(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Level_DEBUG_getInstance() {
    Level_initEntries();
    return Level_DEBUG_instance;
  }
  function Level_INFO_getInstance() {
    Level_initEntries();
    return Level_INFO_instance;
  }
  function Level_WARNING_getInstance() {
    Level_initEntries();
    return Level_WARNING_instance;
  }
  function Level_ERROR_getInstance() {
    Level_initEntries();
    return Level_ERROR_instance;
  }
  function Level_NONE_getInstance() {
    Level_initEntries();
    return Level_NONE_instance;
  }
  function Module(_createdAtStart) {
    _createdAtStart = _createdAtStart === VOID ? false : _createdAtStart;
    this.hs5_1 = _createdAtStart;
    this.is5_1 = generateId(KoinPlatformTools_instance);
    this.js5_1 = LinkedHashSet_init_$Create$();
    this.ks5_1 = LinkedHashMap_init_$Create$();
    this.ls5_1 = LinkedHashSet_init_$Create$();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.ms5_1 = ArrayList_init_$Create$();
  }
  protoOf(Module).ns5 = function (instanceFactory) {
    var def = instanceFactory.as4_1;
    var tmp0 = def.js3_1;
    var tmp2 = def.ks3_1;
    // Inline function 'org.koin.core.definition.indexKey' call
    var scopeQualifier = def.is3_1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    this_0.q(getFullName(tmp0));
    this_0.s(_Char___init__impl__6a9atx(58));
    var tmp1_elvis_lhs = tmp2 == null ? null : tmp2.u1();
    this_0.q(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
    this_0.s(_Char___init__impl__6a9atx(58));
    this_0.w(scopeQualifier);
    var mapping = this_0.toString();
    this.os5(mapping, instanceFactory);
  };
  protoOf(Module).ps5 = function (instanceFactory) {
    this.js5_1.j1(instanceFactory);
  };
  protoOf(Module).os5 = function (mapping, factory) {
    // Inline function 'kotlin.collections.set' call
    this.ks5_1.z2(mapping, factory);
  };
  protoOf(Module).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Module))
      return false;
    return this.is5_1 === other.is5_1;
  };
  protoOf(Module).hashCode = function () {
    return getStringHashCode(this.is5_1);
  };
  function flatten(modules) {
    // Inline function 'kotlin.collections.linkedSetOf' call
    var flatten = LinkedHashSet_init_$Create$();
    var stack = ArrayDeque_init_$Create$(asReversed(modules));
    $l$loop_0: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!stack.r()) {
        break $l$loop_0;
      }
      var current = stack.dh();
      if (!flatten.j1(current)) {
        continue $l$loop_0;
      }
      var _iterator__ex2g4s = asReversed_0(current.ms5_1).t();
      while (_iterator__ex2g4s.u()) {
        var module_0 = _iterator__ex2g4s.v();
        if (!flatten.m1(module_0)) {
          // Inline function 'kotlin.collections.plusAssign' call
          stack.j1(module_0);
        }
      }
    }
    return flatten;
  }
  function throwOverrideError(factory, mapping) {
    throw new DefinitionOverrideException('Already existing definition for ' + factory.as4_1.toString() + ' at ' + mapping);
  }
  var KoinOption_VIEWMODEL_SCOPE_FACTORY_instance;
  var KoinOption_entriesInitialized;
  function KoinOption_initEntries() {
    if (KoinOption_entriesInitialized)
      return Unit_instance;
    KoinOption_entriesInitialized = true;
    KoinOption_VIEWMODEL_SCOPE_FACTORY_instance = new KoinOption('VIEWMODEL_SCOPE_FACTORY', 0);
  }
  function KoinOption(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function hasViewModelScopeFactory(_this__u8e3s4) {
    return _this__u8e3s4.rs5(KoinOption_VIEWMODEL_SCOPE_FACTORY_getInstance()) === true;
  }
  function KoinOption_VIEWMODEL_SCOPE_FACTORY_getInstance() {
    KoinOption_initEntries();
    return KoinOption_VIEWMODEL_SCOPE_FACTORY_instance;
  }
  function getFirstValue($this, clazz) {
    var tmp0 = $this.ss5_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (clazz.ob(element)) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    return tmp$ret$0;
  }
  function getIndexedValue($this, clazz) {
    // Inline function 'kotlin.takeIf' call
    var this_0 = $this.ss5_1.l1($this.us5_1);
    var tmp;
    if (clazz.ob(this_0)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var currentValue = tmp;
    if (!(currentValue == null)) {
      $this.vs5();
    }
    return currentValue;
  }
  function ParametersHolder(_values, useIndexedValues) {
    var tmp;
    if (_values === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    } else {
      tmp = _values;
    }
    _values = tmp;
    useIndexedValues = useIndexedValues === VOID ? null : useIndexedValues;
    this.ss5_1 = _values;
    this.ts5_1 = useIndexedValues;
    this.us5_1 = 0;
  }
  protoOf(ParametersHolder).y2 = function () {
    return this.ss5_1;
  };
  protoOf(ParametersHolder).ws5 = function (i, clazz) {
    var tmp;
    if (i < this.ss5_1.n1()) {
      tmp = this.ss5_1.l1(i);
    } else {
      throw new NoParameterFoundException("Can't get injected parameter #" + i + ' from ' + this.toString() + " for type '" + getFullName(clazz) + "'");
    }
    return tmp;
  };
  protoOf(ParametersHolder).r = function () {
    return this.ss5_1.r();
  };
  protoOf(ParametersHolder).xs5 = function (clazz) {
    var tmp;
    if (this.ss5_1.r()) {
      tmp = null;
    } else {
      var tmp_0;
      switch (this.ts5_1) {
        case null:
          var tmp1_elvis_lhs = getIndexedValue(this, clazz);
          tmp_0 = tmp1_elvis_lhs == null ? getFirstValue(this, clazz) : tmp1_elvis_lhs;
          break;
        case true:
          tmp_0 = getIndexedValue(this, clazz);
          break;
        default:
          tmp_0 = getFirstValue(this, clazz);
          break;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(ParametersHolder).vs5 = function () {
    if (this.us5_1 < get_lastIndex(this.ss5_1)) {
      this.us5_1 = this.us5_1 + 1 | 0;
    }
  };
  protoOf(ParametersHolder).toString = function () {
    return 'DefinitionParameters' + toString_0(toList_0(this.ss5_1));
  };
  protoOf(ParametersHolder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ParametersHolder))
      return false;
    return equals(this.y2(), other.y2()) && this.ts5_1 == other.ts5_1;
  };
  protoOf(ParametersHolder).hashCode = function () {
    var tmp = imul(31, hashCode(this.y2()));
    var tmp0_safe_receiver = this.ts5_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getBooleanHashCode(tmp0_safe_receiver);
    return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  };
  function emptyParametersHolder() {
    return new ParametersHolder();
  }
  function parametersOf(parameters) {
    return new ParametersHolder(toMutableList(parameters));
  }
  function _q(name) {
    return new StringQualifier(name);
  }
  function StringQualifier(value) {
    this.ys5_1 = value;
  }
  protoOf(StringQualifier).u1 = function () {
    return this.ys5_1;
  };
  protoOf(StringQualifier).toString = function () {
    return this.ys5_1;
  };
  protoOf(StringQualifier).hashCode = function () {
    return getStringHashCode(this.ys5_1);
  };
  protoOf(StringQualifier).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StringQualifier))
      return false;
    if (!(this.ys5_1 === other.ys5_1))
      return false;
    return true;
  };
  function TypeQualifier(type) {
    this.zs5_1 = type;
    this.as6_1 = getFullName(this.zs5_1);
  }
  protoOf(TypeQualifier).u1 = function () {
    return this.as6_1;
  };
  protoOf(TypeQualifier).toString = function () {
    return this.as6_1;
  };
  protoOf(TypeQualifier).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof TypeQualifier))
      THROW_CCE();
    if (!(this.as6_1 === other.as6_1))
      return false;
    return true;
  };
  protoOf(TypeQualifier).hashCode = function () {
    return getStringHashCode(this.as6_1);
  };
  function addAllEagerInstances($this, module_0) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = module_0.js5_1.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp0 = $this.us2_1;
      // Inline function 'kotlin.collections.set' call
      var key = element.as4_1.hashCode();
      tmp0.z2(key, element);
    }
  }
  function loadModule($this, module_0, allowOverride) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = module_0.ks5_1.s1().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.component1' call
      var mapping = element.t1();
      // Inline function 'kotlin.collections.component2' call
      var factory = element.u1();
      var hasFactoryAllowOverride = factory.as4_1.os3_1 === true;
      var override = allowOverride || hasFactoryAllowOverride;
      $this.bs6(override, mapping, factory);
    }
  }
  function createEagerInstances($this, instances) {
    var defaultContext = new ResolutionContext($this.ss2_1.cs2_1, $this.ss2_1.es2_1.ns2_1, getKClass(NoClass));
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = instances.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      element.zs3(defaultContext);
    }
  }
  function InstanceRegistry(_koin) {
    this.ss2_1 = _koin;
    this.ts2_1 = KoinPlatformTools_instance.cs6();
    this.us2_1 = KoinPlatformTools_instance.cs6();
  }
  protoOf(InstanceRegistry).vs2 = function (modules, allowOverride) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = modules.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      loadModule(this, element, allowOverride);
      addAllEagerInstances(this, element);
    }
  };
  protoOf(InstanceRegistry).as3 = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.us2_1.y2();
    var tmp$ret$0 = copyToArray(this_0);
    var instances = arrayListOf(tmp$ret$0.slice());
    this.us2_1.c3();
    createEagerInstances(this, instances);
  };
  protoOf(InstanceRegistry).ds6 = function (allowOverride, mapping, factory, logWarning) {
    if (this.ts2_1.w2(mapping) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (!allowOverride) {
        throwOverrideError(factory, mapping);
      } else if (logWarning) {
        this.ss2_1.cs2_1.fs5("(+) override index '" + mapping + "' -> '" + factory.as4_1.toString() + "'");
        var tmp0 = this.us2_1.y2();
        var tmp$ret$2;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            if (element.as4_1.equals(factory.as4_1)) {
              tmp$ret$2 = element;
              break $l$block;
            }
          }
          tmp$ret$2 = null;
        }
        var existingFactory = tmp$ret$2;
        if (!(existingFactory == null)) {
          this.us2_1.a3(factory.as4_1.hashCode());
        }
      }
    }
    this.ss2_1.cs2_1.zs2("(+) index '" + mapping + "' -> '" + factory.as4_1.toString() + "'");
    // Inline function 'kotlin.collections.set' call
    this.ts2_1.z2(mapping, factory);
  };
  protoOf(InstanceRegistry).bs6 = function (allowOverride, mapping, factory, logWarning, $super) {
    logWarning = logWarning === VOID ? true : logWarning;
    var tmp;
    if ($super === VOID) {
      this.ds6(allowOverride, mapping, factory, logWarning);
      tmp = Unit_instance;
    } else {
      tmp = $super.ds6.call(this, allowOverride, mapping, factory, logWarning);
    }
    return tmp;
  };
  protoOf(InstanceRegistry).es6 = function (clazz, qualifier, scopeQualifier) {
    // Inline function 'org.koin.core.definition.indexKey' call
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    this_0.q(getFullName(clazz));
    this_0.s(_Char___init__impl__6a9atx(58));
    var tmp1_elvis_lhs = qualifier == null ? null : qualifier.u1();
    this_0.q(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
    this_0.s(_Char___init__impl__6a9atx(58));
    this_0.w(scopeQualifier);
    var indexKey = this_0.toString();
    return this.ts2_1.w2(indexKey);
  };
  protoOf(InstanceRegistry).fs6 = function (scope) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.ts2_1.y2();
    var factories = copyToArray(this_0);
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = factories.length;
    while (inductionVariable < last) {
      var element = factories[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element instanceof ScopedInstanceFactory) {
        destination.j1(element);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = destination.t();
    while (_iterator__ex2g4s.u()) {
      var element_0 = _iterator__ex2g4s.v();
      element_0.zs4(scope);
    }
  };
  protoOf(InstanceRegistry).a19 = function () {
    return this.ts2_1.n1();
  };
  function OptionRegistry() {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.qs5_1 = HashMap_init_$Create$();
  }
  protoOf(OptionRegistry).rs5 = function (op) {
    return this.qs5_1.w2(op);
  };
  function PropertyRegistry(_koin) {
    this.gs6_1 = _koin;
    this.hs6_1 = KoinPlatformTools_instance.cs6();
  }
  function loadModule_0($this, module_0) {
    $this.ls2_1.o1(module_0.ls5_1);
  }
  function Companion_1() {
    Companion_instance_1 = this;
    this.rs3_1 = '_root_';
    this.ss3_1 = _q('_root_');
  }
  var Companion_instance_1;
  function Companion_getInstance_2() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function ScopeRegistry(_koin) {
    Companion_getInstance_2();
    this.ks2_1 = _koin;
    this.ls2_1 = KoinPlatformTools_instance.is6();
    this.ms2_1 = KoinPlatformTools_instance.cs6();
    this.ns2_1 = new Scope(Companion_getInstance_2().ss3_1, '_root_', true, VOID, this.ks2_1);
    this.ls2_1.j1(this.ns2_1.ns4_1);
    var tmp0 = this.ms2_1;
    var tmp2 = this.ns2_1.os4_1;
    // Inline function 'kotlin.collections.set' call
    var value = this.ns2_1;
    tmp0.z2(tmp2, value);
  }
  protoOf(ScopeRegistry).os2 = function (scopeId, qualifier, source, scopeArchetype) {
    this.ks2_1.cs2_1.zs2("| (+) Scope - id:'" + scopeId + "' q:'" + toString_0(qualifier) + "'");
    if (!this.ls2_1.m1(qualifier)) {
      this.ks2_1.cs2_1.zs2("| Scope '" + toString_0(qualifier) + "' not defined. Creating it ...");
      this.ls2_1.j1(qualifier);
    }
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.ms2_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u2(scopeId)) {
      throw new ScopeAlreadyCreatedException("Scope with id '" + scopeId + "' is already created");
    }
    var tmp0__koin = this.ks2_1;
    var scope = new Scope(qualifier, scopeId, VOID, scopeArchetype, tmp0__koin);
    if (source == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.ks2_1.cs2_1.zs2("|- Scope source set id:'" + scopeId + "' -> " + toString_0(source));
      scope.ts4_1 = source;
    }
    scope.js6([this.ns2_1]);
    // Inline function 'kotlin.collections.set' call
    this.ms2_1.z2(scopeId, scope);
    return scope;
  };
  protoOf(ScopeRegistry).qs2 = function (scopeId) {
    var tmp0_safe_receiver = this.ms2_1.w2(scopeId);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.ks6(tmp0_safe_receiver);
    }
  };
  protoOf(ScopeRegistry).ks6 = function (scope) {
    this.ks2_1.fs2_1.fs6(scope);
    this.ms2_1.a3(scope.os4_1);
  };
  protoOf(ScopeRegistry).ws2 = function (modules) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = modules.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      loadModule_0(this, element);
    }
  };
  function flatten_0(scopes) {
    // Inline function 'kotlin.collections.linkedSetOf' call
    var flatten = LinkedHashSet_init_$Create$();
    var stack = ArrayDeque_init_$Create$(asReversed(scopes));
    $l$loop_0: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!stack.r()) {
        break $l$loop_0;
      }
      var current = stack.dh();
      if (!flatten.j1(current)) {
        continue $l$loop_0;
      }
      var _iterator__ex2g4s = current.ss4_1.t();
      while (_iterator__ex2g4s.u()) {
        var scope = _iterator__ex2g4s.v();
        if (!flatten.m1(scope)) {
          // Inline function 'kotlin.collections.plusAssign' call
          stack.j1(scope);
        }
      }
    }
    return flatten;
  }
  function resolveFromContextOrNull($this, scope, instanceContext) {
    // Inline function 'org.koin.core.resolution.CoreResolverV2.resolveFromInjectedParameters' call
    var tmp;
    if (instanceContext.hs4_1 == null || instanceContext.hs4_1.r()) {
      tmp = null;
    } else {
      tmp = instanceContext.hs4_1.xs5(instanceContext.fs4_1);
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'org.koin.core.resolution.CoreResolverV2.resolveFromStackedParameters' call
        var tmp0_elvis_lhs_0 = scope.vs4_1;
        var tmp_1;
        if (tmp0_elvis_lhs_0 == null) {
          tmp$ret$1 = null;
          break $l$block;
        } else {
          tmp_1 = tmp0_elvis_lhs_0;
        }
        var stack = tmp_1;
        var current = stack.f1i();
        var tmp_2;
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        if (current == null || current.r()) {
          tmp_2 = null;
        } else {
          var parameters = current.wg();
          tmp_2 = parameters == null ? null : parameters.xs5(instanceContext.fs4_1);
        }
        tmp$ret$1 = tmp_2;
      }
      tmp_0 = tmp$ret$1;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? resolveFromRegistry($this, scope, instanceContext) : tmp1_elvis_lhs;
    return tmp2_elvis_lhs == null ? resolveInExtensions($this, scope, instanceContext) : tmp2_elvis_lhs;
  }
  function resolveFromRegistry($this, scope, ctx) {
    var tmp0_elvis_lhs = resolveDirectDefinition($this, scope, ctx);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? resolveFromScopeSource($this, scope, ctx) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? resolveFromLinkedScopes($this, scope, ctx) : tmp1_elvis_lhs;
  }
  function resolveDirectDefinition($this, scope, ctx) {
    var tmp0_elvis_lhs = $this.ls6_1.fs2_1.es6(ctx.fs4_1, ctx.gs4_1, scope.ns4_1);
    var factory = tmp0_elvis_lhs == null ? resolveFromScopeArchetype($this, scope, ctx) : tmp0_elvis_lhs;
    return factory == null ? null : factory.zs3(ctx);
  }
  function resolveFromScopeArchetype($this, scope, ctx) {
    if (scope.ps4_1)
      return null;
    var tmp0_safe_receiver = scope.qs4_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      ctx.js4_1 = tmp0_safe_receiver;
      tmp = $this.ls6_1.fs2_1.es6(ctx.fs4_1, ctx.gs4_1, tmp0_safe_receiver);
    }
    return tmp;
  }
  function resolveFromScopeSource($this, scope, ctx) {
    if (scope.ps4_1 || !(ctx.gs4_1 == null))
      return null;
    return ctx.fs4_1.ob(scope.ts4_1) ? scope.ts4_1 : null;
  }
  function resolveFromLinkedScopes($this, scope, ctx) {
    var scopes = plus(listOf(scope), flatten_0(scope.ss4_1));
    var resolvedScope = null;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var _iterator__ex2g4s = scopes.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var definition = findDefinitionInScope($this, element, ctx);
        if (!(definition == null)) {
          resolvedScope = element;
        }
        var result = definition;
        if (!(result == null)) {
          tmp$ret$0 = result;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    var factory = tmp$ret$0;
    var tmp0_elvis_lhs = resolvedScope;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var foundScope = tmp;
    if (factory == null)
      return null;
    var newCtx = ctx.ms4(foundScope);
    if (!(foundScope.qs4_1 == null) && !foundScope.ps4_1) {
      newCtx.js4_1 = foundScope.qs4_1;
    }
    var tmp_0;
    if (!(newCtx.hs4_1 == null)) {
      tmp_0 = newCtx.es4_1.ns6(newCtx.hs4_1);
    } else {
      tmp_0 = null;
    }
    var paramStack = tmp_0;
    var value = factory.zs3(newCtx);
    if (paramStack == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      newCtx.es4_1.os6(paramStack);
    }
    return value;
  }
  function findDefinitionInScope($this, scope, ctx) {
    var tmp0_safe_receiver = scope.qs4_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = $this.ls6_1.fs2_1.es6(ctx.fs4_1, ctx.gs4_1, tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? $this.ls6_1.fs2_1.es6(ctx.fs4_1, ctx.gs4_1, scope.ns4_1) : tmp1_elvis_lhs;
  }
  function resolveInExtensions($this, scope, ctx) {
    var tmp0 = $this.ms6_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        ctx.ds4_1.zs2("|- ['" + element.m() + "'] ?");
        var result = element.ps6(scope, ctx);
        if (!(result == null)) {
          tmp$ret$0 = result;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    return tmp$ret$0;
  }
  function CoreResolverV2(_koin) {
    this.ls6_1 = _koin;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.ms6_1 = ArrayList_init_$Create$();
  }
  protoOf(CoreResolverV2).qs6 = function (scope, instanceContext) {
    var tmp0_elvis_lhs = resolveFromContextOrNull(this, scope, instanceContext);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'org.koin.core.resolution.CoreResolverV2.throwNoDefinitionFound' call
      var tmp0_safe_receiver = instanceContext.gs4_1;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = " and qualifier '" + toString_0(tmp0_safe_receiver) + "'";
      }
      var tmp1_elvis_lhs = tmp_0;
      var qualifierString = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      throw new NoDefinitionFoundException("No definition found for type '" + getFullName(instanceContext.fs4_1) + "'" + qualifierString + " on scope '" + instanceContext.es4_1.toString() + "'. Check your Modules configuration and add missing type and/or qualifier!");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  function resolve($this, clazz, qualifier, parameters) {
    parameters = parameters === VOID ? null : parameters;
    var tmp0 = $this.rs4_1.cs2_1;
    // Inline function 'org.koin.core.logger.Logger.isAt' call
    var lvl = Level_DEBUG_getInstance();
    if (!(tmp0.ys2_1.i3(lvl) <= 0)) {
      return resolveInstance($this, qualifier, clazz, parameters);
    }
    // Inline function 'org.koin.core.scope.Scope.logInstanceRequest' call
    var tmp;
    if (qualifier == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = " with qualifier '" + toString_0(qualifier) + "'";
    }
    var tmp1_elvis_lhs = tmp;
    var qualifierString = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    var scopeId = $this.ps4_1 ? '' : " - scope:'" + $this.os4_1 + "'";
    $this.rs4_1.cs2_1.fs3(Level_DEBUG_getInstance(), "|- '" + getFullName(clazz) + "'" + qualifierString + scopeId + '...');
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.time.measureTimedValue' call
    var mark = Monotonic_instance.mf();
    var result = resolveInstance($this, qualifier, clazz, parameters);
    var result_0 = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    // Inline function 'org.koin.core.scope.Scope.logInstanceDuration' call
    var duration = result_0.rq_1;
    $this.rs4_1.cs2_1.fs3(Level_DEBUG_getInstance(), "|- '" + getFullName(clazz) + "' in " + get_inMs(duration) + ' ms');
    return result_0.qq_1;
  }
  function resolveInstance($this, qualifier, clazz, parameters) {
    // Inline function 'org.koin.core.scope.Scope.checkScopeIsOpen' call
    if ($this.ws4_1) {
      throw new ClosedScopeException("Scope '" + $this.os4_1 + "' is closed");
    }
    var instanceContext = new ResolutionContext($this.rs4_1.cs2_1, $this, clazz, qualifier, parameters);
    return stackParametersCall($this, parameters, instanceContext);
  }
  function stackParametersCall($this, parameters, instanceContext) {
    if (parameters == null) {
      return resolveFromContext($this, instanceContext);
    }
    var tmp0 = $this.rs4_1.cs2_1;
    // Inline function 'org.koin.core.logger.Logger.log' call
    var lvl = Level_DEBUG_getInstance();
    // Inline function 'org.koin.core.logger.Logger.isAt' call
    if (tmp0.ys2_1.i3(lvl) <= 0) {
      var tmp$ret$2 = '| >> parameters ' + parameters.toString();
      tmp0.fs3(lvl, tmp$ret$2);
    }
    var stack = $this.ns6(parameters);
    try {
      return resolveFromContext($this, instanceContext);
    }finally {
      $this.rs4_1.cs2_1.zs2('| << parameters');
      $this.os6(stack);
    }
  }
  function getOrCreateParameterStack($this) {
    var tmp0_elvis_lhs = $this.rs6().f1i();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.let' call
      var it = ArrayDeque_init_$Create$_0();
      $this.rs6().r3e(it);
      tmp = it;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function resolveFromContext($this, instanceContext) {
    return $this.rs4_1.ds2_1.qs6($this, instanceContext);
  }
  function Scope$_get_parameterStack_$lambda_2hcjn3(this$0) {
    return function () {
      var tmp0_elvis_lhs = this$0.vs4_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.also' call
        var this_0 = new ThreadLocalRef();
        this$0.vs4_1 = this_0;
        tmp = this_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      return tmp;
    };
  }
  function Scope(scopeQualifier, id, isRoot, scopeArchetype, _koin) {
    isRoot = isRoot === VOID ? false : isRoot;
    scopeArchetype = scopeArchetype === VOID ? null : scopeArchetype;
    this.ns4_1 = scopeQualifier;
    this.os4_1 = id;
    this.ps4_1 = isRoot;
    this.qs4_1 = scopeArchetype;
    this.rs4_1 = _koin;
    this.ss4_1 = ArrayList_init_$Create$();
    this.ts4_1 = null;
    this.us4_1 = LinkedHashSet_init_$Create$();
    this.vs4_1 = null;
    this.ws4_1 = false;
  }
  protoOf(Scope).k4b = function () {
    return this.ws4_1;
  };
  protoOf(Scope).rs6 = function () {
    var tmp0_elvis_lhs = this.vs4_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0 = KoinPlatformTools_instance;
      tmp = tmp_0.as5(this, Scope$_get_parameterStack_$lambda_2hcjn3(this));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(Scope).js6 = function (scopes) {
    if (!this.ps4_1) {
      this.ss4_1.e3(0, toList(scopes));
    } else {
      // Inline function 'kotlin.error' call
      var message = "Can't add scope link to a root scope";
      throw IllegalStateException_init_$Create$(toString_0(message));
    }
  };
  protoOf(Scope).ss6 = function (clazz, qualifier, parameters) {
    return resolve(this, clazz, qualifier, parameters == null ? null : parameters());
  };
  protoOf(Scope).ts6 = function (clazz, qualifier, parameters, $super) {
    qualifier = qualifier === VOID ? null : qualifier;
    parameters = parameters === VOID ? null : parameters;
    return $super === VOID ? this.ss6(clazz, qualifier, parameters) : $super.ss6.call(this, clazz, qualifier, parameters);
  };
  protoOf(Scope).us6 = function (clazz, qualifier, parameters) {
    return resolve(this, clazz, qualifier, parameters);
  };
  protoOf(Scope).ns6 = function (parameters) {
    var stack = getOrCreateParameterStack(this);
    stack.zg(parameters);
    return stack;
  };
  protoOf(Scope).os6 = function (stack) {
    stack.ch();
    if (stack.r()) {
      this.rs6().l4();
    }
  };
  protoOf(Scope).vs6 = function () {
    return this.rs4_1;
  };
  protoOf(Scope).toString = function () {
    return "['" + this.os4_1 + "']";
  };
  function get_inMs(_this__u8e3s4) {
    // Inline function 'kotlin.Long.div' call
    var this_0 = _Duration___get_inWholeMicroseconds__impl__8oe8vv(_this__u8e3s4);
    return toNumber(this_0) / 1000.0;
  }
  function module_0(createdAtStart, moduleDeclaration) {
    createdAtStart = createdAtStart === VOID ? false : createdAtStart;
    var module_0 = new Module(createdAtStart);
    moduleDeclaration(module_0);
    return module_0;
  }
  function get_classNames() {
    _init_properties_KClassExt_kt__5ro5b2();
    return classNames;
  }
  var classNames;
  function getFullName(_this__u8e3s4) {
    _init_properties_KClassExt_kt__5ro5b2();
    var tmp0_elvis_lhs = get_classNames().w2(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? saveCache(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  function saveCache(_this__u8e3s4) {
    _init_properties_KClassExt_kt__5ro5b2();
    var name = KoinPlatformTools_instance.ws6(_this__u8e3s4);
    // Inline function 'kotlin.collections.set' call
    get_classNames().z2(_this__u8e3s4, name);
    return name;
  }
  var properties_initialized_KClassExt_kt_dizwhw;
  function _init_properties_KClassExt_kt__5ro5b2() {
    if (!properties_initialized_KClassExt_kt_dizwhw) {
      properties_initialized_KClassExt_kt_dizwhw = true;
      classNames = KoinPlatformTools_instance.cs6();
    }
  }
  function KoinPlatform() {
  }
  protoOf(KoinPlatform).vs6 = function () {
    return KoinPlatformTools_instance.gs3().f1i();
  };
  var KoinPlatform_instance;
  function KoinPlatform_getInstance() {
    return KoinPlatform_instance;
  }
  function getKClassDefaultName(_this__u8e3s4, kClass) {
    return 'KClass@' + kClass.hashCode();
  }
  function register($this, koinApplication) {
    if (!($this.xs6_1 == null)) {
      throw new KoinApplicationAlreadyStartedException('A Koin Application has already been started');
    }
    $this.xs6_1 = koinApplication.bs3_1;
  }
  function GlobalContext() {
    this.xs6_1 = null;
  }
  protoOf(GlobalContext).f1i = function () {
    var tmp0_elvis_lhs = this.xs6_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'KoinApplication has not been started';
      throw IllegalStateException_init_$Create$(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(GlobalContext).hs3 = function (appDeclaration) {
    var koinApplication = Companion_instance.df7();
    register(this, koinApplication);
    appDeclaration(koinApplication);
    return koinApplication;
  };
  var GlobalContext_instance;
  function GlobalContext_getInstance() {
    return GlobalContext_instance;
  }
  function generateId(_this__u8e3s4) {
    return Companion_getInstance().kr().toString();
  }
  function KoinPlatformTools() {
  }
  protoOf(KoinPlatformTools).ks4 = function (e) {
    return e.toString() + toString_0(split(Exception_init_$Create$().toString(), ['\n']));
  };
  protoOf(KoinPlatformTools).ws6 = function (kClass) {
    var tmp0_elvis_lhs = kClass.o();
    return tmp0_elvis_lhs == null ? getKClassDefaultName(this, kClass) : tmp0_elvis_lhs;
  };
  protoOf(KoinPlatformTools).ys6 = function (kClass) {
    return kClass.o();
  };
  protoOf(KoinPlatformTools).gs3 = function () {
    return GlobalContext_instance;
  };
  protoOf(KoinPlatformTools).as5 = function (lock, block) {
    return block();
  };
  protoOf(KoinPlatformTools).cs6 = function () {
    return ConcurrentMutableMap_init_$Create$();
  };
  protoOf(KoinPlatformTools).is6 = function () {
    return ConcurrentMutableSet_init_$Create$();
  };
  var KoinPlatformTools_instance;
  function KoinPlatformTools_getInstance() {
    return KoinPlatformTools_instance;
  }
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  KoinPlatform_instance = new KoinPlatform();
  GlobalContext_instance = new GlobalContext();
  KoinPlatformTools_instance = new KoinPlatformTools();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_getInstance_2;
  _.$_$.b = KoinPlatformTools_instance;
  _.$_$.c = KoinPlatform_instance;
  _.$_$.d = Kind_Factory_getInstance;
  _.$_$.e = Kind_Singleton_getInstance;
  _.$_$.f = startKoin;
  _.$_$.g = BeanDefinition;
  _.$_$.h = KoinDefinition;
  _.$_$.i = FactoryInstanceFactory;
  _.$_$.j = SingleInstanceFactory;
  _.$_$.k = hasViewModelScopeFactory;
  _.$_$.l = ParametersHolder;
  _.$_$.m = parametersOf;
  _.$_$.n = TypeQualifier;
  _.$_$.o = module_0;
  _.$_$.p = generateId;
  //endregion
  return _;
}));

//# sourceMappingURL=projects-core-koin-core.js.map
